import { inject as I, getCurrentInstance as v, watch as m, onBeforeUnmount as p } from "vue";
function j(o, s, u) {
  var f;
  const e = I(o, null);
  if (e === null)
    return;
  const d = (f = v()) === null || f === void 0 ? void 0 : f.proxy;
  m(u, a), a(u.value), p(() => {
    a(void 0, u.value);
  });
  function a(n, i) {
    const t = e[s];
    i !== void 0 && r(t, i), n !== void 0 && c(t, n);
  }
  function r(n, i) {
    n[i] || (n[i] = []), n[i].splice(n[i].findIndex((t) => t === d), 1);
  }
  function c(n, i) {
    n[i] || (n[i] = []), ~n[i].findIndex((t) => t === d) || n[i].push(d);
  }
}
export {
  j as useInjectionInstanceCollection
};
